import { DetailWrapper } from "../../../../../features/ui"
import { CustomerDetail } from "./customerDetail"

export const CustomerDetailLoader = () => (
    <DetailWrapper>
        <CustomerDetail />
    </DetailWrapper>
)
